import { render, staticRenderFns } from "./DossierField.vue?vue&type=template&id=be2bbed8&scoped=true&"
import script from "./DossierField.vue?vue&type=script&setup=true&lang=js&"
export * from "./DossierField.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DossierField.vue?vue&type=style&index=0&id=be2bbed8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2bbed8",
  null
  
)

export default component.exports